var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F3BA2F;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_00000098206311452814790940000009959879603912675771_",
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.9,395.1l110.7-110.7l110.8,110.7l64.4-64.4L440.6,155.6L265.5,330.7L329.9,395.1 M155.6,440.6l64.4-64.4 l64.4,64.4L220,505L155.6,440.6z M329.9,486.1l110.7,110.7L551.4,486l64.4,64.4l0,0L440.6,725.6L265.5,550.5l-0.1-0.1L329.9,486.1  M596.8,440.6l64.4-64.4l64.4,64.4L661.2,505L596.8,440.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M505.9,440.6L505.9,440.6l-65.3-65.4l-48.3,48.3h0l-5.5,5.6l-11.4,11.4l-0.1,0.1l0.1,0.1l65.3,65.3 L505.9,440.6L505.9,440.6L505.9,440.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbIcon);
export default __webpack_public_path__ + "static/media/bnb_icon.e3f798da772e3527bf740f6522d0f586.svg";
export { ForwardRef as ReactComponent };